import LibrarySection from './components/LibrarySection.vue'
import LibraryDocument from './components/LibraryDocument.vue'

export default [
  {
    path: 'library',
    alias: '',
    component: LibrarySection,
    name: 'Library - all sections',
    meta: {description: 'View and Search all Documents in the Library'}
  },
  {
    path: 'library/section/:id',
    alias: '',
    component: LibrarySection,
    name: 'Library - section',
    meta: {description: 'View Documents in this Section'}
  },
  {
    path: 'library/document/new',
    alias: '',
    component: LibraryDocument,
    name: 'Library - New Document',
    meta: {description: 'Add a New Library Document'}
  },
  {
    path: 'library/document/:id',
    alias: '',
    component: LibraryDocument,
    name: 'Library - document',
    meta: {description: 'Viewing a Library Document'}
  },
  {
    path: 'library/document/:id/edit',
    alias: '',
    component: LibraryDocument,
    name: 'Library - Editing document',
    meta: {description: 'Editing a Library Document'}
  }
]



// WEBPACK FOOTER //
// ./src/modules/library/routes.js